// import './App.css';
import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Homepage from "./Components/HomePage/Homepage";
import "./redesign.css";

const RoomList = React.lazy(() => import("./Components/booking/RoomList"));
const HotelsList = React.lazy(() => import("./Components/HotelsList/HotelsList"));
const BookingSummary = React.lazy(() => import("./Components/booking/BookingSummary"));
const BookingPage = React.lazy(() => import("./Components/booking/BookingPage"));
const EventHall = React.lazy(() => import("./Components/hero/EventHall"));
const OurSpecialPromo = React.lazy(() => import("./Components/hero/OurSpecialPromo"));
const NavAbout = React.lazy(() => import("./Components/hero/NavAbout"));
const Login = React.lazy(() => import("./Components/Auth/Login"));
const Register = React.lazy(() => import("./Components/Auth/Register"));
const Favourites = React.lazy(() => import("./Components/Favourites/Favourites"));
const Page404 = React.lazy(() => import("./Utilities/page404/Page404"));

const LoadingFallback = () => (
  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
    <div style={{ width: 32, height: 32, border: "3px solid #e0e0e0", borderTopColor: "#2e2d90", borderRadius: "50%", animation: "spin 0.8s linear infinite" }} />
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

function App() {
  return (
    <div className="App">
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/favourites" element={<Favourites />} />
          <Route path="/availablehotels" element={<HotelsList />} />
          <Route path="/hotel-rooms/:hotelName/:hotelId/:string" element={<RoomList />} />
          <Route path="/reservation/:reservationId" element={<BookingPage />} />
          <Route path="/bookingSummary" element={<BookingSummary />} />
          <Route path="/EventHall" element={<EventHall />} />
          <Route path="/Special-Promo" element={<OurSpecialPromo />} />
          <Route path="/About-Residency-Hotels" element={<NavAbout />} />
          <Route path="*" element={<Page404 />} />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
